import AxiosClient from "../../../services/axios.services";

class TotalCompetenceServices {
  getTotalCompetence = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_competencia_total/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getTotalCompetenceById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_competencia_total/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveTotalCompetence = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_competencia_total/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editTotalCompetence = (id, data) =>
    AxiosClient.put(
      `/api/app/descriptor_perfil_competencia_total/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteTotalCompetence = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_competencia_total/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new TotalCompetenceServices();
